var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { id: "top" },
    },
    [
      _vm.isInternetExplorer ? _c("warning-internet-explorer") : _vm._e(),
      _vm._v(" "),
      _c("wa-admin-bar"),
      _vm._v(" "),
      _vm._t("tophat", function () {
        return [
          _c("subscription-notices"),
          _vm._v(" "),
          _c("usage-notices"),
          _vm._v(" "),
          _vm.isShowingV7PrereleaseNotice
            ? _c("v7-prerelease-notice", {
                on: { "show-livestream-modal": _vm.showLivestreamModal },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._t("header"),
      _vm._v(" "),
      _vm.isShowingBandana
        ? _vm._t("bandana", function () {
            return [
              _c("wa-bandana", {
                attrs: { "bandana-name": "v7TeaserBandana" },
                on: { "show-livestream-modal": _vm.showLivestreamModal },
              }),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("sweatband"),
      _vm._v(" "),
      _vm._t("content"),
      _vm._v(" "),
      _vm._t("sock"),
      _vm._v(" "),
      _vm._t("footer"),
      _vm._v(" "),
      _vm.isShowingSitewideModal
        ? _vm._t("sitewide-modal", function () {
            return [
              _c("wa-modal-v7-livestream", {
                attrs: { "is-showing": _vm.isShowingSitewideModal },
                on: { "close-modal": _vm.hideLivestreamModal },
              }),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("overlay"),
      _vm._v(" "),
      _c("cookie-consent"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }